export const environment = {
  API_URL: "https://api-trinity-concrete-dev.thedeev.com/",
  EXPORT_URL: "https://api-export-trinity-concrete-dev.thedeev.com/",
};
